export default __webpack_public_path__ + "assets/media/50149108.jpg";